module.exports = __webpack_public_path__ + "img/info-ico.0f46c2ad.svg";